.hug-content-footer {
  margin: var(--rc-theme-spacing-lg) calc(-1 * var(--rc-theme-spacing-lg)) 0;
  padding: 0 var(--rc-theme-spacing-lg);
  padding-top: var(--rc-theme-spacing-lg);
  border-top: var(--rc-theme-border-base);
}
